window.$ = window.jQuery = require('jquery')

// Angular 1
require('angular');
require('angular-resource');
require('angular-animate');
require('angular-cookies');
require('angular-sanitize');
require('angular-messages');
require('angular-route');

window.moment = require('moment')
require('moment/locale/en-ca.js')
require('moment/locale/fr-ca.js')
require('moment/locale/fr.js')
require('angular-moment')
require('moment-range')
require('moment-weekday-calc')

require('d3/d3')
require('angular_d3')

const numbro = require('numbro')
window.numeral = numbro

const numbroFr = require('numbro/languages/fr-CA')
numbro.culture('fr', numbroFr)
numbro.culture('fr-ca', numbroFr)
numbro.culture('fr-CA', numbroFr)
const numbroEn = numbro.cultures()['en-US']
numbro.culture('en', numbroEn)
numbro.culture('en-ca', numbroEn)
numbro.culture('en-CA', numbroEn)

require('pusher-js')
require('pusher-angular')
require('angular-ui-mask')
require('ng-csv')

require('extensions')

require('./views');
require('./filters');
require('./directives');
require('./services');

const Sentry = require('@sentry/browser');

angular.module('wealthbar', [
  'wbViews', 'ngAnimate', 'ngCookies', 'ngSanitize', 'ngMessages',
  'wbServices', 'wbControllers', 'wbDirectives', 'wbComponents',
  'wbFilters', 'ui.bootstrap', 'ui.mask', 'pusher-angular', 'ngCsv', 'ad3',
  'angularMoment'
])

.config([
  '$anchorScrollProvider',
  function($anchorScrollProvider, config) {
    $anchorScrollProvider.disableAutoScrolling()
  }
])

.config([ '$provide', function($provide) {
  $provide.decorator('$locale', ['$delegate', function($delegate) {
    if ($delegate.id === 'en-us') {
      $delegate.NUMBER_FORMATS.PATTERNS[1].negPre = '-\u00A4'
    }
    $delegate.NUMBER_FORMATS.PATTERNS[1].negSuf = ''
    return $delegate
  }])
}])

.config(['$compileProvider', function($compileProvider) {
  // Disable debug info in production
  $compileProvider.debugInfoEnabled(window.process.env.ENV !== 'production')
}])

.factory('$exceptionHandler', ['$log', function($log) {
  return function(e, c) {
    var userId = null
    if (window.currentUser) {
      userId = window.currentUser.id
    }
    $log.error.apply($log, arguments)
    Sentry.captureException(e, {
      extra: { userId: userId }
    })
  }
}])

require('./components');
require('./controllers');
